import { render, staticRenderFns } from "./Resales.vue?vue&type=template&id=7b88c8b7"
import script from "./Resales.vue?vue&type=script&lang=js"
export * from "./Resales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports